import { Tabs as TabsPrimitive } from "radix-ui";
// eslint-disable-next-line import/no-namespace -- shadcn vendor file
import * as React from "react";

import { cn } from "../../lib/utils";

function Tabs({ ...properties }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" {...properties} />;
}

function TabsList({ className, ...properties }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "border-(--color-border-default-base) font-(--font-weight-semibold) text-(--color-text-default-muted) inline-flex w-fit items-center justify-center border-b",
        className
      )}
      {...properties}
    />
  );
}

function TabsTrigger({ className, ...properties }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "data-[state=active]:border-primary data-[state=active]:text-primary",
        "px-(--spacing-6) py-(--spacing-4) inline-flex items-center justify-center whitespace-nowrap border-b-2 border-transparent outline-none transition-all",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring focus-visible:ring-1",
        "disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...properties}
    />
  );
}

function TabsContent({ className, ...properties }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content data-slot="tabs-content" className={cn("flex-1 outline-none", className)} {...properties} />
  );
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
